<template>
  <div>
    <DashboardSummaryHeader>
      <BalanceCardV2 slot="left" />
      <NextPaymentV3 slot="right" />
    </DashboardSummaryHeader>

    <b-container class="px-0 pt-1">
      <!-- Componente grafico consolidado por linha  -->
      <b-row id="consolidateChart">
        <b-col cols="12" class="py-3">
          <ConsolidatedChartCard />
        </b-col>
      </b-row>
      <!-- Componente grafico consolidado por linha  -->
      <b-row>
        <!-- componente grafico geral de ganhos por modelo -->
        <b-col id="performanceGraph" cols="12" lg="3" class="px-3 py-3">
          <PerformanceGraph :height="'260'" :graphData="graphData" />
        </b-col>
        <!-- componente grafico geral de ganhos por modelo -->

        <!-- componente link personalizado -->
        <b-col id="LinkFormCard" cols="12" lg="9" class="py-3">
          <LinkFormCard />
        </b-col>
        <!-- componente link personalizado -->
      </b-row>
    </b-container>

    <b-modal id="modalTour" ref="modalTour" :hide-footer="true">
      <template class="d-flex" slot="modal-header">
        <span class="close-modal ml-auto" @click="setTour(false)">X</span>
      </template>
      <b-row class="alert p-4 d-flex align-items-center">
        <b-container class="p-0">
          <b-row class="p-2 d-flex align-items-center">
            <b-col cols="10" class="m-auto">
              <img max-width="353" class="img-fluid" src="@/assets/images/logo-escuro.svg" alt="" />
            </b-col>
          </b-row>
          <b-row class="p-2 mt-4">
            <h1 class="title py-3">Bem-vindo ao UOL afiliados</h1>
            <p class="text-tour">
              Comece a aumentar seus rendimentos com sites, blogs e redes
              sociais. Escolha entre uma grande variedade de anúncios e comece a
              divulgar!
            </p>
            <p class="text-tour">
              <strong>Você gostaria de ser guiado em sua primeira divulgação?</strong>
            </p>
          </b-row>
          <b-row class="p-0 mt-4 d-flex">
            <b-col cols="8" class="ml-auto d-flex">
              <button class="btnTour ml-3 pt-2 pb-2" @click="setTour(true)">
                Vamos começar
              </button>
              <button class="btnNotTour ml-auto pt-2 pb-2" @click="setTour(false)">
                Fechar
              </button>
            </b-col>
          </b-row>
        </b-container>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NextPaymentV3 from '@/components/NextPaymentV3';
import PerformanceGraph from '@/components/PerformanceGraph';
import LinkFormCard from '@/components/LinkFormCard';
import ConsolidatedChartCard from '@/components/ConsolidatedChartCard';
import BalanceCardV2 from '@/components/BalanceCardV2';
import DashboardSummaryHeader from '@/components/DashboardSummaryHeader';
import ReportsApi from '@/services/reports';
import dashboardTour from '@/services/tour/dashboard';
import {
  checkMustShowTour,
  USER_OPT_OUT,
  getTourKey,
} from '@/services/tour/tourUtils';

export default {
  name: 'Dashboard',
  components: {
    NextPaymentV3,
    PerformanceGraph,
    LinkFormCard,
    ConsolidatedChartCard,
    BalanceCardV2,
    DashboardSummaryHeader,
  },
  data() {
    return {
      graphData: {
        colors: ['#FF8400', '#F2B370', '#C17E35', '#E04E00'],
        data: {
          CPA: [
            {
              type: 'Total de cliques',
              value: 0,
            },
            {
              type: 'Total de pedidos',
              value: 0,
            },
            {
              type: 'Confirmações',
              value: 0,
            },
            {
              type: 'Total de ganhos (R$)',
              value: 0,
            },
          ],
          CPL: [
            {
              type: 'Total de cliques',
              value: 0,
            },
            {
              type: 'Total de pedidos',
              value: 0,
            },
            {
              type: 'Confirmações',
              value: 0,
            },
            {
              type: 'Total de ganhos (R$)',
              value: 0,
            },
          ],
        },
        descriptionText: `
        Aqui mostramos
        o número total de todas as
        campanhas que você está veiculando nos últimos 30 dias
        `,
      },
    };
  },
  computed: {
    ...mapGetters(['enabledFeatures']),
  },
  methods: {
    setTour(tourEnabled) {
      if (tourEnabled) {
        this.$refs.modalTour.hide();
        this.startTour();
      } else {
        localStorage.setItem(getTourKey('dashboard', USER_OPT_OUT), true);
        this.$refs.modalTour.hide();
      }
    },
    startTour() {
      dashboardTour.start();
    },
    ...mapActions(['fetchBalanceInfo', 'fetchBalanceData']),
    async fetchCPAReportData() {
      const cpaReportData = await ReportsApi.getCPAReport();
      this.graphData.data.CPA[0].value = cpaReportData.reportResult.numClick;
      this.graphData.data.CPA[1].value = cpaReportData.reportResult.numOrder;
      this.graphData.data.CPA[2].value = cpaReportData.reportResult.numPayment;
      this.graphData.data.CPA[3].value = cpaReportData.reportResult.numSupplierWinValue;
    },
  },
  mounted() {
    if (checkMustShowTour('dashboard')) {
      if (window.outerWidth > 600) {
        this.$refs.modalTour.show();
      }
    }
  },
  async created() {
    await this.fetchBalanceInfo();
    await this.fetchBalanceData();
    await this.fetchCPAReportData();
  },
};
</script>

<style lang="scss" scoped>
/deep/ {
  .top-resume h1 {
    color: $text-warning;
    margin-left: auto;
  }

  .link {
    color: $denim;
  }
}

#modalTour .modal-content {
  border-radius: 10px !important;
  font-family: $font-1;
}

.title {
  font-weight: bold;
  font-family: $font-1;
}

.btnTour {
  -moz-box-shadow: 0 3px 0 0 $piper;
  -webkit-box-shadow: 0 3px 0 0 $piper;
  box-shadow: 0 3px 0 0 $piper;
  background-color: #e57f44;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  border: none;
  width: 130px;
  font-family: $font-1;
}

.btnNotTour {
  font-family: $font-1;
  width: 130px;
  -moz-box-shadow: 0px 3px 0 0 #cbcbcb;
  -webkit-box-shadow: 0px 3px 0 0 #cbcbcb;
  box-shadow: 0px 3px 0 0 #cbcbcb;
  background-color: #e8e8e8;
  color: $denim;
  font-size: 15px;
  font-weight: bold;
  border: none;
}

.shepherd-element .shepherd-content footer .shepherd-buttons {
  display: flex !important;
}

.shepherd-modal-target {
  padding-top: 10px;
}

@media screen and (max-width: 600px) {
  .link {
    margin-right: auto;
  }

  .top-resume h1 {
    font-size: $font-size-xs-big;
  }
}
</style>
